import { v4 as uuid } from 'uuid';
import { isObject } from '@/utils';

interface IStore {
  // 原始URL
  initUrl?: string;
  // 全局数据
  globalInfo?: Record<string, string | number | undefined>;
  // 页面数据
  pageInfo?: Record<string, string | number | undefined>;
  // 页面数据储物柜，页面 ”指定事件独享数据“
  cabinet?: {
    [x: string]: Record<string, string | number | undefined>;
  };
}

class LogStorage {
  constructor() {
    try {
      this.store = {
        initUrl: undefined,
        pageInfo: undefined,
        globalInfo: undefined,
        cabinet: undefined,
      };
    } catch {
      // do nothing
    }
  }

  store: IStore = {};

  // 设置首次加载的url
  setInitUrl = (initUrl: string) => {
    try {
      this.store.initUrl = initUrl;
    } catch {
      // do nothing
    }
  };

  // 获取首次加载的url
  get initUrl() {
    return (this.store.initUrl || '') as string;
  }

  // 设置来源url
  setOriginUrl = (originUrl: string) => {
    try {
      this.store.globalInfo = {
        ...this.globalInfo,
        originUrl,
      };
    } catch {
      // do nothing
    }
  };

  // 获取来源url
  get originUrl() {
    return (this.globalInfo?.originUrl || '') as string;
  }

  // 更新sessionId, 主要用于url携带sessionId场景
  setTrackId(trackId?: string | number) {
    try {
      this.store.globalInfo = {
        ...this.globalInfo,
        trackId,
      };
    } catch {
      // do nothing
    }
  }

  // 分享人ID
  setShareUid = (shareUid: string, shareUidValue: string) => {
    try {
      this.store.globalInfo = {
        ...this.globalInfo,
        shareUid: shareUidValue,
      };
    } catch {
      // do nothing
    }
  };

  get getShareUid() {
    return (this.globalInfo?.shareUid || '') as string;
  }

  // 获取trackId
  get trackId() {
    return this.globalInfo?.trackId;
  }

  // 更新moduleMark
  setModuleMark(moduleMark?: string | number) {
    try {
      this.store.globalInfo = {
        ...this.globalInfo,
        moduleMark,
        trackId: moduleMark ? uuid() : undefined,
      };
    } catch {
      // do nothing
    }
  }

  // 获取moduleMark
  get moduleMark() {
    return this.globalInfo?.moduleMark;
  }

  // 设置pageMark
  setPageMark(pageMark?: string | number) {
    try {
      this.store.globalInfo = {
        ...this.globalInfo,
        pageMark,
        sessionId: uuid(),
      };
    } catch {
      // do nothing
    }
  }

  setSessionId(sessionId?: string) {
    try {
      this.store.globalInfo = {
        ...this.globalInfo,
        sessionId,
      };
    } catch {
      // do nothing
    }
  }

  // 获取pageMark
  get pageMark() {
    return this.globalInfo.pageMark;
  }

  // 获取全局数据
  get globalInfo() {
    try {
      return {
        ...(this.store.globalInfo || {}),
      } as Record<string, any>;
    } catch {
      return {} as Record<string, any>;
    }
  }

  // 全局数据插入
  setGlobalInfo(
    globalInfo: {
      unionId: string[] | string | undefined;
      latitude: string[] | string | undefined;
      miniScene: string[] | string | undefined;
      openGid: string[] | string | undefined;
      longitude: string[] | string | undefined;
    },
    reset?: boolean,
  ) {
    try {
      this.store.globalInfo = reset
        ? globalInfo
        : { ...this.store.globalInfo, ...globalInfo };
      if ('moduleMark' in (globalInfo || {})) {
        this.setModuleMark(globalInfo.moduleMark);
      }
      if ('trackId' in (globalInfo || {})) {
        this.setTrackId(globalInfo.trackId);
      }
    } catch {
      // do nothing
    }
  }

  // 重置全局数据
  resetGlobalInfo(globalInfo: Record<string, string | number | undefined>) {
    try {
      this.setGlobalInfo(globalInfo, true);
    } catch {
      // do nothing
    }
  }

  // 更新页面数据，页面储物柜数据同时清空
  setPageInfo(pageInfo: Record<string, string | number | undefined>) {
    try {
      this.store.pageInfo = { ...this.store.pageInfo, ...pageInfo };
    } catch {
      // do nothing
    }
  }

  // 获取指定页面数据
  get pageInfo() {
    try {
      return this.store.pageInfo || {};
    } catch {
      return {};
    }
  }

  // 重置页面数据，页面储物柜数据同时清空
  resetPageInfo(pageInfo?: Record<string, string | number | undefined>) {
    try {
      this.store.pageInfo = pageInfo;
      this.store.cabinet = undefined;
    } catch {
      // do nothing
    }
  }

  // 设置页面储物柜数据
  setPageCabinet(
    key: string | Record<string, Record<string, string | number | undefined>>,
    value?: Record<string, string | number | undefined>,
  ) {
    try {
      if (isObject(key)) {
        this.store.cabinet = {
          ...(this.store?.cabinet || {}),
          ...key,
        };
      } else {
        this.store.cabinet = {
          ...(this.store?.cabinet || {}),
          [key]: value || {},
        };
      }
    } catch {
      // do nothing
    }
  }

  // 获取事件数据
  getPageCabinet(event: string) {
    try {
      return this.store.cabinet?.[event] || {};
    } catch {
      return {};
    }
  }
}

export default new LogStorage();
